import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import ExpenseList from "../ExpenseList";

function AdminExpense(){
    const[searchUi,setSearchUi]=useState(true)
    const[searchContent,setSearchContent]=useState('')
    
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={5}
        childrenPage={<ExpenseList/>}/>
        </DataContext.Provider>
    )
}

export default AdminExpense;